import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import dashboardIcon from '../assets/Dashboard.png';
import SizeupIcon from "../assets/Sizeup.png";
import userIcon from '../assets/user.png';
import axios from 'axios';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleFindCounselor = () => {
    const success = (position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      const geoApiUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`;

      fetch(geoApiUrl)
        .then((res) => res.json())
        .then((data) => {
          console.log("Detected state:", data.principalSubdivision);
          findCounselor(data.principalSubdivision);
        })
        .catch((err) => {
          console.error("Error during geolocation fetch:", err);
        });
    };

    const error = () => {
      console.error("Error getting user location");
    };

    const findCounselor = async (state) => {
      try {
        const response = await axios.get(`/api/counselors/${state}`);
        if (response.data.length > 0) {
          navigate("/booking", { state: { counselor: response.data[0] } });
        } else {
          alert("Coming soon to your state");
        }
      } catch (err) {
        console.error("Error fetching counselor:", err);
      }
    };

    navigator.geolocation.getCurrentPosition(success, error);
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <nav className="hidden md:flex flex-col justify-between bg-white shadow-md fixed top-0 left-0 h-screen w-40 p-6 z-50">
        {/* Top Section */}
        <div className="flex flex-col items-center space-y-8">
          <img src={logo} alt="Logo" className="w-32 h-12 object-contain" />
          <Link to="/Dashboard">
            <img src={dashboardIcon} alt="Dashboard" className="h-10 w-10" />
          </Link>
          <Link to="/Sizeup">
            <img src={SizeupIcon} alt="Sizeup" className="h-10 w-10" />
          </Link>
          <Link to="/Profile">
            <img src={userIcon} alt="Profile" className="h-10 w-10" />
          </Link>
        </div>

        {/* Bottom Button */}
        <div className="mb-6">
          <button
            onClick={handleFindCounselor}
            className="w-full bg-[#e53935] text-white text-sm px-4 p-3 rounded-lg hover:bg-black hover:text-white mb-2"
          >
            Find Counselor
          </button>
        </div>
      </nav>

      {/* Mobile Top Nav */}
      <nav className="md:hidden bg-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="flex justify-between items-center px-4 py-3">
          <img src={logo} alt="Logo" className="h-10" />
          <button onClick={toggleMenu} className="text-gray-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="px-4 pb-3">
            <ul className="flex flex-col space-y-2">
              <li><Link to="/Dashboard">Dashboard</Link></li>
              <li><Link to="/Sizeup">Size-up</Link></li>
              <li><Link to="/Profile">Profile</Link></li>
              <li>
                <button
                  onClick={handleFindCounselor}
                  className="bg-red-500 text-white text-sm px-3 py-1 rounded hover:bg-red-600"
                >
                  Find Counselor
                </button>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navigation;

